import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, watch } from 'vue';
import AuraComposer from '@/views/pages/aura/components/AuraComposer.vue';
import { useAuraStore, useFilterStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraChat',
  setup(__props, { expose: __expose }) {
  __expose();

/**
 * AURA Chat - Main chat view component
 * Main chat interface integrating all sub-components
 */
const isLoading = ref(true);
const auraStore = useAuraStore();
const filterStore = useFilterStore();
const levelId = computed(() => filterStore.level?.id ?? null);

watch(
    levelId,
    () => {
        auraStore.reset(true);
    },
    { immediate: true },
);

onMounted(async () => {
    // Composer loads the real AURA context from the backend.
    isLoading.value = false;
});

const __returned__ = { isLoading, auraStore, filterStore, levelId, AuraComposer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})